import { postRequest } from "../system/serverCall";
import serverResponseHandler from "../system/serverResponseHandler";

const dfStartOrchestrator = (data) => {
  return postRequest(
    `df-orchestrator-http-start/${data.storeId}?orchestrator=${data.orchestrator}`,
    data,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

export const systemService = { dfStartOrchestrator };
